import React, { useEffect, useState } from 'react'
import ApiGo from '../../../../actions/ApiGo'
import { useSelector } from 'react-redux';
import { useTranslation } from 'react-i18next';
import TimeSelector from './TimeSelector';
import { LogTime } from '../../../../actions/forFrontEnd_Log';
import UiIntegrater from '../littleUIComponent/UiIntegrater'
import { HR, RR } from './SVGRRHR';

const HISVitalAbnormal =(props)=>{
    const resident_data = props.data
    const {t} = useTranslation()

    const store_timestamp = useSelector(state=>state.store_historyData.timestamp)
    const store_start = useSelector(state => state.store_historyData.timestampBegin)
    const store_end = useSelector(state => state.store_historyData.timestampEnd)

    const [date, setDate] = useState(0);

    const [timeSelector, setTimeSelector] = useState(false);
    const [breathRow, setBreathRow] = useState([]);
    const [reset, setReset] = useState(false);

    const [start, setStart] = useState(Number(store_start) || 0);
    const [end, setEnd] = useState(Number(store_end) || 0);
    const [timeInterval, setTimeInterval] = useState([0,0]);

    const getTZOffset = () => (8 * 60 + new Date().getTimezoneOffset()) * 60000;
    const tzOffset = getTZOffset()

    function toggoleTimeSelctor(){
        setTimeSelector(!timeSelector)
    }

    function toggleReset(timeStart, timeEnd){
        setStart(Number(timeStart))
        setEnd(Number(timeEnd))
        setTimeInterval([timeStart, timeEnd])
        setReset(true)
    }

    const formatTime = (ts) => {
        if (!ts || isNaN(ts)) return "--"
        return new LogTime(new Date(Number(ts) + tzOffset))
            .getFullTime_withoutSec_and_Millsec()
    }

    useEffect(()=>{
        if(!store_start || !store_end) return

        const _start = Number(store_start)
        const _end = Number(store_end)

        setStart(_start)
        setEnd(_end)

        const _date_obj = new Date(_end + tzOffset)
        const _date_obj_previous = new Date(_start + tzOffset)

        const _date_previous = new LogTime(_date_obj_previous).getFullTime_withoutMillsec()
        const _date = new LogTime(_date_obj).getFullTime_withoutMillsec()

        setDate(store_timestamp)

        if(!reset){
            ApiGo.postHR_RR_abnormal_info(
                resident_data.id,
                resident_data.heart_high,
                resident_data.heart_low,
                resident_data.breath_high,
                resident_data.breath_low,
                _date_previous,
                _date
            )
            .then(res=>{
                setBreathRow(res)
            })
            .catch(()=>{
                setBreathRow([])
            })
        }

    }, [store_timestamp, store_start, store_end])

    useEffect(()=>{
        if(!reset) return
        if(!timeInterval[0] || !timeInterval[1]) return

        ApiGo.postHR_RR_abnormal_info(
            resident_data.id,
            resident_data.heart_high,
            resident_data.heart_low,
            resident_data.breath_high,
            resident_data.breath_low,
            timeInterval[0],
            timeInterval[1]
        )
        .then(res=>{
            setBreathRow(res)
        })
        .catch(()=>{
            setBreathRow([])
        })
        .finally(()=>{
            setReset(false)
        })

    }, [reset, timeInterval])

    return(
    <>
    <UiIntegrater
        OnOff_switch={[true, false, false, true, true]}
        date={new Date()}
        name={resident_data?.last_name || ""}
        bed={resident_data?.first_name || ""}
    />

    <div className="fx-d-c h-90">
        <div className="fx-d-r fx-fsc timeslecMobile h-5 timePresent frame" onClick={toggoleTimeSelctor} >
            <div className="br-10 time_pink fx-ccc w-20 cursor pt h-100">
                {t("HISTORY_RECORD.TIME_SELECT")}
            </div>

            {timeSelector &&
                <TimeSelector
                    hide={toggoleTimeSelctor}
                    toggleReset={toggleReset}
                    setTimeInterval={setTimeInterval}
                />
            }

            <div className='timeslecMobile fx-d-r fx-cspar content'>
                {t("HISTORY_RECORD.CHOSEN_TIME")} &nbsp; : &nbsp;
                {formatTime(start)}
                &nbsp;&nbsp; - &nbsp;&nbsp;
                {formatTime(end)}
            </div>
        </div>

        <div className="fx-d-r fx-ccc font-ml frame-title _1 pad-5 t">
            <div className="col-2 fx-ccc row_title">{t('GLOBAL.DATE')}</div>
            <div className="col-2 fx-ccc row_title">{t('GLOBAL.TIME')}</div>
            <div className="col-2 fx-ccc row_title">{t('GLOBAL.TYPE')}</div>
            <div className="col-2 fx-ccc row_title">{t('HISTORY_RECORD.RECORD')}</div>
            <div className="col-2 fx-ccc row_title">{t('HISTORY_RECORD.LIMIT')}</div>
        </div>

        <div className='frame-table'>
            <VitalRowAbnormal breathData={breathRow}/>
        </div>
    </div>
    </>
    );
}

export default HISVitalAbnormal;

const VitalRowAbnormal =(props)=>{
    const {t} = useTranslation()
    let brow = props.breathData

    function sampleReturn(value, high, low){
        if(value>high){return t("DASHBOARD.UPPER")+":"+high}
        return t("DASHBOARD.LOWER")+":"+low
    }

    return(
        <div className='max-hig-withTimeSelector'>
            {brow.map((row)=>
                <div key={row.id} className="fx-d-r fx-ccc font-ml cardDefaultCF his">
                    <div className="col-2 fx-ccc row_body odd">{row.created_at.split('T')[0]}</div>
                    <div className="col-2 fx-ccc row_body even">{row.created_at.split('T')[1]}</div>

                    <div className={`col-2 fx-ccc row_body ${row.type==="rr"? "br":"hr"}`}>
                        {row.type==="rr"? <RR type="icon_pic"/>:<HR type="icon_pic"/>}
                        &nbsp;{row.type==="rr"? t("DASHBOARD.BREATH"):t("DASHBOARD.HEART")}
                    </div>

                    <div className={`col-2 fx-ccc row_body ${row.type==="rr"? "br":"hr"}`}>
                        {row.value} {t("HISTORY_RECORD.TIMES_MIN")}
                    </div>

                    <div className={`col-2 fx-ccc row_body ${row.type==="rr"? "br":"hr"}`}>
                        {sampleReturn(row.value, row.upper_limit, row.lower_limit)}
                    </div>
                </div>
            )}
        </div>
    );
}